module.exports = __webpack_public_path__ + "static/media/level-1-blue.ec9713c2.svg";